// The columns Recordings and dates and Webinars read (docs/data-model.md 4.2, 4.4, 4.5, 4.6), in 1
// place, so the screens, the e2e recording (tests/e2e/fixtures/admin-content/print-sql.mjs) and its
// replay all ask for the same thing. Pure: no imports.
//
// Each list differs from the Library's own reads (tests/e2e/support/hub.js SELECTS), so a replay never
// answers one of these with a member's rows. The catalogue's settings are read for cohort_naming only
// (PostgREST's json path, as cohort_naming). created_by says a product was made in admin (the
// product-types plan, 13 Oct: a new on-demand course's modules are listed to take their recordings).
export const COLUMNS = {
  catalogue: 'id, slug, path, name, type, access_kind, state, look, moved_in, sort_order, release_basis, default_session_minutes, cohort_naming:settings->cohort_naming, created_by',
  // deal_surgery: Profit On Your Terms's switch per intake (data-model 10.6.2)
  cohorts: 'id, product_id, name, kind, schedule_label, starts_on, ends_on, weeks_total, number, sort_order, deal_surgery',
  cohort_links: 'cohort_id, whatsapp_invite_url',
  modules: 'id, product_id, key, label, number, title, sort_order, is_published',
  sessions: 'id, product_id, cohort_id, module_id, number, title, starts_at, duration_minutes, zoom_join_url, status',
  // thumbnail_path: the recording's own thumbnail in the covers bucket (decision 47, 12 Oct)
  recordings: 'id, product_id, module_id, session_id, cohort_id, key, part, title, recorded_on, sort_order, is_published, published_at, thumbnail_path',
  recording_content: 'recording_id, vimeo_url, vimeo_id, vimeo_hash, duration_seconds, chapters, summary, key_messages, tags',
  homework_items: 'id, product_id, module_id, recording_id, group_heading, time_label, body, kind, sort_order, removed_at',
  resource_sections: 'id, product_id, name, sort_order',
  resource_placements: 'id, item_id, product_id, section_id, module_id, recording_id, removed_at',
  client_spaces: 'id, product_id, client_person_id, ended_at, opened_at',
  people: 'id, first_name, full_name',
  client_sessions: 'id, space_id, number, title, starts_at, duration_minutes',
  client_session_notes: 'session_id, recording_url, duration_seconds, notes, shown_at',
  // register lines (the Accelerator critique's P2, 20 Oct): the held rows' counts, and a mastermind register's
  // caught-up days (caught_up_on, set only through hub.record_catch_up)
  attendance: 'session_id, person_id, status, caught_up_on',
  // thumbnail_path: the webinar's own thumbnail in the covers bucket (Adam, 9 Oct); register_slug, register_on and
  // register_list_name: its register page (docs/replay-register-spec.md 3.1, 23 Oct)
  webinars: 'id, product_id, title, description, starts_at, duration_minutes, registration_url, shown, sells_product_id, cta_text, cta_label, cta_url, replay_url, replay_up, replay_chapters, replay_duration_seconds, thumbnail_path, register_slug, register_on, register_list_name',
}

// The same list without spaces, as supabase-js sends it in ?select=
export const flatColumns = table => COLUMNS[table].replace(/\s+/g, '')

// A list as SQL's select list: PostgREST's alias:col->key becomes col->'key' as alias
export const sqlColumns = table => COLUMNS[table].split(',').map(s => s.trim()).map(s => {
  const m = /^(\w+):(\w+)->(\w+)$/.exec(s)
  return m ? `${m[2]}->'${m[3]}' as ${m[1]}` : s
}).join(', ')
